import React from "react";
import { useGame } from "../context/GameContext";

const Notifications = () => {
  const { notifications, approveHintRequest, rejectHintRequest } = useGame();

  if (notifications.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {notifications.map((notif) => (
        <div
          key={notif.id}
          className={`px-5 py-3 rounded-lg shadow-lg max-w-sm animate-slide-in ${
            notif.type === "success"
              ? "bg-green-500 text-white"
              : notif.type === "error"
                ? "bg-red-500 text-white"
                : notif.type === "hint_request"
                  ? "bg-indigo-600 text-white"
                  : "bg-blue-500 text-white"
          }`}
        >
          <p className="font-semibold text-sm">{notif.message}</p>
          {notif.type === "hint_request" && (
            <div className="flex gap-2 mt-2">
              <button
                onClick={() => approveHintRequest(notif.targetPlayerId)}
                className="flex-1 bg-green-500 hover:bg-green-400 text-white font-semibold py-1.5 px-3 rounded-md text-sm transition duration-150"
              >
                Accepter
              </button>
              <button
                onClick={() => rejectHintRequest(notif.targetPlayerId)}
                className="flex-1 bg-red-500 hover:bg-red-400 text-white font-semibold py-1.5 px-3 rounded-md text-sm transition duration-150"
              >
                Refuser
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Notifications;
